export class EmailAccount {
    constructor(id, type, email, fromName) {
        this.id = id;
        this.type = type;
        this.email = email;
        this.fromName = fromName;
    }
}
